var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"SectionAccordion"},[_c('Wrap',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }